module.exports = __webpack_public_path__ + "img/brand-nissan.aee85850.png";